import { render, staticRenderFns } from "./VerlaufHeader.vue?vue&type=template&id=6fbf5352&scoped=true&"
import script from "./VerlaufHeader.vue?vue&type=script&lang=js&"
export * from "./VerlaufHeader.vue?vue&type=script&lang=js&"
import style0 from "./VerlaufHeader.vue?vue&type=style&index=0&id=6fbf5352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbf5352",
  null
  
)

export default component.exports